import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "txt-center": "",
  style: {"max-width":"350px"},
  "m-t-0": "",
  "m-rl-auto": ""
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "App-U-Info-Modal-Secs" }
const _hoisted_5 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": false,
      "close-on-click-modal": false,
      onOpen: _ctx.opened,
      title: "Create Profile",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("p", _hoisted_1, [
            (_ctx.user.type === 'talent')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Next up, we will require you to fill-in the following details, so we can match you with opportunities that leverage your skillsets. "))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, " Fill-in the following details to create a profile account for you and your co-founders. "))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_space, {
              alignment: "left",
              size: 10,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.title,
                    class: "App-U-Info-Modal-Sec"
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                      primary: "",
                      "f-w-700": "",
                      class: "el-icon-circle-check"
                    }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(section.title), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_space, {
              direction: "vertical",
              size: 12,
              "w-100": "",
              fill: ""
            }, {
              default: _withCtx(() => [
                false
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      "is-all-borderless": "",
                      plain: "",
                      class: "Btn-Linkedin",
                      "is-block": "",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Import From LinkedIn ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  onClick: _ctx.submit,
                  "is-borderless": "",
                  plain: "",
                  type: "primary",
                  "is-block": "",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Continue ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "onOpen"])
  ]))
}